import React, {useContext, useState} from 'react';
import {createPortal} from 'react-dom';
import {useTranslation} from 'react-i18next';
import {CSSTransition} from 'react-transition-group';
import clsx from 'clsx';

import {Theme} from '../contexts/theme';

import ArrowIcon from './arrow-icon';

import styles from './side-modal.module.css';

export default ({toggleSideModal, renderContent}) => {
  const [inProp, setInProp] = useState(true);
  const theme = useContext(Theme);
  const {t} = useTranslation();

  const handleClose = () => {
    setInProp(false);

    setTimeout(() => toggleSideModal({isOpen: false, props: {}}), 250);
  };

  return createPortal(
    <div className={styles.sideModal}>
      <CSSTransition
        in={inProp}
        timeout={250}
        classNames='sideLeft'
        appear
      >
        <div className={clsx(styles.modalContent, styles[`modalContent${theme}`])}>
          <button
            className={styles.button}
            onClick={handleClose}
          >
            <ArrowIcon className={clsx(styles.arrowIcon, styles[`arrowIcon${theme}`])} />
            <span className={clsx(styles.buttonText, styles[`buttonText${theme}`])}>
              {t('fifa2022.sideModalText')}
            </span>
          </button>
          {renderContent()}
        </div>
      </CSSTransition>
      <CSSTransition
        in={inProp}
        timeout={250}
        classNames='fade'
        appear
      >
        <div
          onClick={handleClose}
          className={styles.backdrop}
        />
      </CSSTransition>
    </div>
    , document.body);
};
